import React from 'react';

import { useIntl } from 'react-intl';

import Popup from '@atlaskit/popup';

import { MoreAppsOrHideTile } from '../../../../common/ui/drag-and-drop/more-apps-or-hide-tile';
import type { AppTileConfig } from '../../../../types';
import { messages } from '../../messages';
import { MoreApps } from '../index';

export type MoreAppsPopupProps = {
	appTiles: AppTileConfig[];
	isDragActive: boolean;
	isOpen: boolean;
	onClose: () => void;
	onOpen: () => void;
	testIdPrefix: string;
};

export function MoreAppsPopup({
	appTiles,
	isDragActive,
	isOpen,
	onClose,
	onOpen,
	testIdPrefix,
}: MoreAppsPopupProps): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<Popup
			placement="right-start"
			isOpen={isOpen}
			onClose={onClose}
			content={() => (
				<MoreApps
					appItems={[]}
					atlassianAppsItems={appTiles.map((app) => ({
						productId: app.productId,
						title: app.title,
						url: app.href,
					}))}
					integrationsAppsItems={[]}
					marketplaceAppsItems={[]}
				/>
			)}
			trigger={(triggerProps) => (
				<MoreAppsOrHideTile
					onClick={onOpen}
					isDragActive={isDragActive}
					moreLabel={formatMessage(messages.exampleMoreAppsText)}
					hideLabel={formatMessage(messages.exampleHideText)}
					testIdPrefix={testIdPrefix}
					triggerProps={triggerProps}
				/>
			)}
			shouldRenderToParent
		/>
	);
}
